import * as localforage from 'localforage';
import LogName from '../logname';
import { query, mutation } from '../graphql/graphql';
import { currentDate } from '../utils/helpers';

export default class LogStorage {
  logName = null;
  // Connection with Apollo GraphQL
  apollo = null;
  // User ipAddress
  ipAddress = null;
  // Token
  storage = {
    token: window.localStorage.getItem('access_token'),
    uf: null,
    home: false,
  };

  inRequest = false;

  report = {
    canal_id: null,
    url: null,
    uf_id: null,
    uf_sigla: null,
    produto_id: null,
    produto_nome: null,
    noticia_id: null,
    titulo: null,
    so: null,
    ip: null,
    navegador: null,
    acao: 'navegacao',
    acao_navegacao: '',
  };

  isAction = null;

  isProdutoNome = window.localStorage.getItem('@logger:vivoconsulta:aparelho') || '';

  constructor(apollo, ipAddress, EventBus) {
    // Set LogName super();
    // super();
    // localForage

    // localforage.config({
    //   driver: localforage.INDEXEDDB,
    //   name: '@logger.revista',
    // });

    // Apollo
    this.apollo = apollo;
    // Meu Ip
    this.ipAddress = ipAddress;

    this.eventBus = EventBus;

    // Clean Logs
    // this.clear(currentDate());

    this.eventBus.$on('tb-action', ({ modelo, action }) => {
      this.isAction = action;
      this.isProdutoNome = modelo;
      window.localStorage.setItem('@logger:vivoconsulta:aparelho', modelo ? modelo : '');
    });
  }

  setReport(report, page = null) {
    this.report.canal_id = report.canal.id;
    this.report.url = report.route.fullPath;
    this.report.uf_id = report.uf_id;
    this.report.uf_sigla = report.uf;
    this.report.noticia_id = page ? page.noticia_id : null;
    this.report.titulo = page ? page.titulo : null;
    this.report.so = report.navigator.platform;
    this.report.ip = report.ipAddress;
    this.report.navegador = report.navigator.userAgent;
    this.report.produto_nome = page && page.produto_nome ? page.produto_nome : '';
    this.report.produto_id = page && page.produto_id ? page.produto_id : null;
    this.report.acao_navegacao = page && page.acao_navegacao ? page.acao_navegacao : '';
  }

  getReport() {
    return this.report;
  }

  async init(data) {
    data.ipAddress = this.ipAddress;
    const { route } = data;
    const access = this.getPageAccess(route);
    await this.prepareLog(data, access);
    await this.createStorageLogger(data, this.getReport());
  }

  async createLoggerPages(report, access) {
    try {
      if (access.report === 'post') {
        const {
          data: { data },
        } = await query(this.apollo, access.report, {
          modulo: report.modulo,
          canal: report.canal.id,
          slug: access.slug,
          uf: [report.uf],
        });
        const [logger] = data.response;
        return { noticia_id: logger.id, titulo: logger.titulo };
      }

      if (access.report === 'tabela-preco-page') {
        console.log(this.apollo);

        const acao_navegacao = access.action;
        const produto_nome = access.produto_nome;
        const produto_id = access.params.id;

        return { acao_navegacao, produto_id, produto_nome };
      }
    } catch (e) {
      console.log(e);
    }
  }

  prepareLog(data, access) {
    return new Promise(async (resolve, reject) => {
      try {
        if (access && access.gql) {
          const page = await this.createLoggerPages(data, access);
          // this.logName = `${currentDate()}.${page.noticia_id}.${data.uf}.${this.storage.token}`;
          this.setReport(data, page);
          resolve(true);
        } else if (access && access.report === 'home') {
          // this.logName = `${currentDate()}.home.${data.uf}.${this.storage.token}`;
          this.setReport(data, null);
          resolve(true);
        }
      } catch (e) {
        console.log(e);
      }
    });
  }

  // async clear(data) {
  //   try {
  //     await this.clearLogger(data);
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  getPageAccess(to) {
    const { name, params, path } = to;
    switch (name) {
      case 'home':
        return { report: 'home', path, gql: false };
      case 'categoria':
        return {
          report: 'categoria',
          slug: params.categoria,
          path,
          gql: true,
        };
      case 'post':
        return {
          report: 'post',
          slug: params.noticia,
          path,
          gql: true,
        };
      case 'vivo.consulta.home':
        return {
          report: 'tabela-preco-home',
          path,
          params,
          gql: true,
        };
      case 'vivo.consulta.page':
        const action = this.isAction;
        const produtoNome = this.isProdutoNome;
        this.isAction = null;
        console.log(action);
        return {
          report: 'tabela-preco-page',
          action,
          path,
          produto_id: params.id,
          produto_nome: produtoNome,
          params,
          gql: true,
        };
      default:
        return null;
    }
  }

  async createStorageLogger({ uf }, report) {
    const { storage } = this;
    const token = window.localStorage.getItem('access_token');

    try {
      if (storage.token === null || storage.token !== token) storage.token = token;
      if (storage.uf === null || storage.uf !== uf) storage.uf = uf;

      if (!uf) {
        throw 'Problema na UF';
      }
      // if (await localforage.getItem(this.logName)) {
      //   throw 'Logue já cadastrado';
      // }
      await this.saveStorageLogger(report);
    } catch (e) {
      console.log(e);
    }
  }

  // async findInStorage() {
  //   try {
  //     const log = await localforage.getItem(this.logName);
  //     return log;
  //   } catch (e) {
  //     console.log(e);
  //   }
  // }

  async saveStorageLogger(storage) {
    try {
      // if (!this.logName) {
      //   throw 'LogName não foi gerado!';
      // }
      // await this.saveLogName(this.logName);
      // await localforage.setItem(this.logName, storage);
      await this.saveLogDB(storage);
    } catch (e) {
      console.log(e);
    }
  }

  async saveLogDB(db) {
    try {
      console.log(db);
      const {
        data: { registrarLog },
      } = await mutation(this.apollo, db);
      // await this.saveRegister(registrarLog.id);
    } catch (e) {
      console.log('Log Register');
    }
  }
}
